module.exports = __webpack_public_path__ + "static/media/9DESA17.f21d12fe.jpg";